export let process = {
  // cwd: () => '',
  env: {}, // to avoid `process.env` undefined in runtime
}
